import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[appQueryRemoveButton]' })
export class QueryRemoveButtonDirective
{
  constructor(public template: TemplateRef<any>) { }
}
